// src/utils/toastUtils.js
import { toast } from "sonner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export const renderShortId = (longID) => {
    return longID.substring(0, 7);
};

export const makeIdentifyToast = (id, msg, icon) =>
    toast(
      <span className="toast-text">
        <FontAwesomeIcon icon={icon} size="xs" />
        <b> {renderShortId(id)}</b> {msg}
      </span>,
      {
        duration: 7500,
      },
    );